module.exports = __webpack_public_path__ + "media/13-1.c0128873.mp4";